var map = {
	"./UTMCAPS-logo-white.svg": 3551,
	"./UTMCAPS-logo.svg": 5199,
	"./ig-card.png": 9401,
	"./jpg/homePage/banner.jpg": 4075,
	"./jpg/homePage/placeholder-our-board.jpg": 920,
	"./jpg/homePage/placeholder-our-supporters.jpg": 3981,
	"./jpg/homePage/placeholder-who-we-are.jpg": 1513,
	"./jpg/placeholder1.jpg": 2080,
	"./logo.png": 3153,
	"./png/homePage/logo-blue-s.png": 9919,
	"./png/homePage/logo-white-b.png": 1821,
	"./svg/instagram.svg": 6137,
	"./svg/keyboard_arrow_down_24dp_2C3E50_FILL1_wght400_GRAD0_opsz24.svg": 615,
	"./svg/keyboard_arrow_left_24dp_E8EAED_FILL0_wght400_GRAD0_opsz24.svg": 5973,
	"./svg/keyboard_arrow_right_24dp_2C3E50_FILL0_wght400_GRAD0_opsz24.svg": 940,
	"./svg/keyboard_arrow_up_24dp_2C3E50_FILL1_wght400_GRAD0_opsz24.svg": 7078,
	"./svg/linkedin.svg": 6749,
	"./svg/mail_24dp_2C3E50_FILL1_wght400_GRAD0_opsz24.svg": 1930,
	"./svg/wechat.svg": 6005,
	"./svg/xiaohongshu.svg": 4790,
	"./title-icon.png": 9384,
	"./wehchat-card.png": 6421,
	"./xhs-card.png": 9762
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;